"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Recommendation = void 0;
var resource_type_enum_1 = require("../../../constants/resource-type.enum");
/**
 * It holds information about recommendation
 *
 * @property {string}           externalTemplateId    - Unique identifier for the assessment template associated to the recommendation
 * @property {string}           externalItemId          - External identifier for the item
 * @property {string}           cmsResourceId           - Id for the resource at the CMS
 * @property {string}           cmsResourceLabel        - Label for the resource at the CMS
 * @property {ResourceType}     cmsResourceType         - Type for the resource at the CMS
 */
var Recommendation = /** @class */ (function () {
    function Recommendation(summary) {
        if (summary === void 0) { summary = {}; }
        Object.assign(this, summary);
    }
    Object.defineProperty(Recommendation.prototype, "isSupportingContent", {
        get: function () {
            return this.cmsResourceType === resource_type_enum_1.ResourceType.SupportingContent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Recommendation.prototype, "isFollowUpAssessment", {
        get: function () {
            return this.cmsResourceType === resource_type_enum_1.ResourceType.FollowUpAssessment;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Return the recommendations given the ResourceType from the recommendations list
     * @param {Recommendation[]}    recommendations
     * @param {ResourceType}        resourceType
     * @returns {Recommendation[]} the recommendations
     */
    Recommendation.findRecommendationsByType = function (recommendations, recommendationType) {
        return recommendations.filter(function (_a) {
            var cmsResourceType = _a.cmsResourceType;
            return cmsResourceType === recommendationType;
        });
    };
    return Recommendation;
}());
exports.Recommendation = Recommendation;
